/* eslint-disable no-confusing-arrow */
import _ from 'underscore';

export const displayAdsAspectRatioConfig = {
  // display ad aspect ratios
  Image300x250: {
    aspectRatio: 1.2,
    aspectRatioAsRatio: '300:250',
    type: 'Image300x250',
    editorTitle: () => _TL_('Edit image: 300:250 aspect ratio'),
  },
  Image728x90: {
    aspectRatio: 8.088888888888889,
    aspectRatioAsRatio: '728:90',
    type: 'Image728x90',
    editorTitle: () => _TL_('Edit image: 728:90 aspect ratio'),
  },
  Image160x600: {
    aspectRatio: 0.26666666666666666,
    aspectRatioAsRatio: '160:600',
    type: 'Image160x600',
    editorTitle: () => _TL_('Edit image: 160:600 aspect ratio'),
  },
  Image300x600: {
    aspectRatio: 0.5,
    aspectRatioAsRatio: '300:600',
    type: 'Image300x600',
    editorTitle: () => _TL_('Edit image: 300:600 aspect ratio'),
  },
  Image120x600: {
    aspectRatio: 0.2,
    aspectRatioAsRatio: '120:600',
    type: 'Image120x600',
    editorTitle: () => _TL_('Edit image: 120:600 aspect ratio'),
  },
  Image468x60: {
    aspectRatio: 7.8,
    aspectRatioAsRatio: '468:60',
    type: 'Image468x60',
    editorTitle: () => _TL_('Edit image: 468:60 aspect ratio'),
  },
  Image336x280: {
    aspectRatio: 1.2,
    aspectRatioAsRatio: '336:280',
    type: 'Image336x280',
    editorTitle: () => _TL_('Edit image: 336:280 aspect ratio'),
  },
  Image250x250: {
    aspectRatio: 1,
    aspectRatioAsRatio: '250:250',
    type: 'Image250x250',
    editorTitle: () => _TL_('Edit image: 250:250 aspect ratio'),
  },
  Image180x150: {
    aspectRatio: 1.2,
    aspectRatioAsRatio: '180:150',
    type: 'Image180x150',
    editorTitle: () => _TL_('Edit image: 180:150 aspect ratio'),
  },
  Image970x250: {
    aspectRatio: 3.88,
    aspectRatioAsRatio: '970:250',
    type: 'Image970x250',
    editorTitle: () => _TL_('Edit image: 970:250 aspect ratio'),
  },
  Image234x60: {
    aspectRatio: 3.9,
    aspectRatioAsRatio: '234:60',
    type: 'Image234x60',
    editorTitle: () => _TL_('Edit image: 234:60 aspect ratio'),
  },
  Image970x90: {
    aspectRatio: 10.777777777777779,
    aspectRatioAsRatio: '970:90',
    type: 'Image970x90',
    editorTitle: () => _TL_('Edit image: 970:90 aspect ratio'),
  },
  Image320x50: {
    aspectRatio: 6.4,
    aspectRatioAsRatio: '320:50',
    type: 'Image320x50',
    editorTitle: () => _TL_('Edit image: 320:50 aspect ratio'),
  },
  Image300x50: {
    aspectRatio: 6,
    aspectRatioAsRatio: '300:50',
    type: 'Image300x50',
    editorTitle: () => _TL_('Edit image: 300:50 aspect ratio'),
  },
  Image320x480: {
    aspectRatio: 0.6666666666666666,
    aspectRatioAsRatio: '320:480',
    type: 'Image320x480',
    editorTitle: () => _TL_('Edit image: 320:480 aspect ratio'),
  },
  Image480x320: {
    aspectRatio: 1.5,
    aspectRatioAsRatio: '480:320',
    type: 'Image480x320',
    editorTitle: () => _TL_('Edit image: 480:320 aspect ratio'),
  },
  Image320x100: {
    aspectRatio: 3.2,
    aspectRatioAsRatio: '320:100',
    type: 'Image320x100',
    editorTitle: () => _TL_('Edit image: 320:100 aspect ratio'),
  },
  Image216x36: {
    aspectRatio: 6,
    aspectRatioAsRatio: '216:36',
    type: 'Image216x36',
    editorTitle: () => _TL_('Edit image: 216:36 aspect ratio'),
  },
  Image168x28: {
    aspectRatio: 6,
    aspectRatioAsRatio: '168:28',
    type: 'Image168x28',
    editorTitle: () => _TL_('Edit image: 168:28 aspect ratio'),
  },
  Image120x20: {
    aspectRatio: 6,
    aspectRatioAsRatio: '120:20',
    type: 'Image120x20',
    editorTitle: () => _TL_('Edit image: 120:20 aspect ratio'),
  },
};

export const imageExtensionAspectRatioConfig = {
  // image extension aspect ratios
  Image172x100: {
    aspectRatio: 1.72,
    aspectRatioAsRatio: '172:100',
    type: 'Image172x100',
    editorTitle: () => _TL_('Edit image: 172:100 aspect ratio'),
  },
  Image155x100: {
    aspectRatio: 1.55,
    aspectRatioAsRatio: '155:100',
    type: 'Image155x100',
    editorTitle: () => _TL_('Edit image: 155:100 aspect ratio'),
  },
  Image93x100: {
    aspectRatio: 0.93,
    aspectRatioAsRatio: '93:100',
    type: 'Image93x100',
    editorTitle: () => _TL_('Edit image: 93:100 aspect ratio'),
  },
};

export const boostAspectRatioConfig = {
  Image57x100: {
    aspectRatio: 0.57,
    aspectRatioAsRatio: '0.57:1',
    type: 'Image57x100',
    editorTitle: () => _TL_('Edit image: 0.57 : 1 aspect ratio'),
  },
  Image122x100: {
    aspectRatio: 1.225,
    aspectRatioAsRatio: '1.225:1',
    type: 'Image122x100',
    editorTitle: () => _TL_('Edit image: 1.225 : 1 aspect ratio'),
  },
  Image159x100: {
    aspectRatio: 1.59,
    aspectRatioAsRatio: '1.59:1',
    type: 'Image159x100',
    editorTitle: () => _TL_('Edit image: 1.59 : 1 aspect ratio'),
  },
  Image180x100: {
    aspectRatio: 1.805,
    aspectRatioAsRatio: '1.805:1',
    type: 'Image180x100',
    editorTitle: () => _TL_('Edit image: 1.805 : 1 aspect ratio'),
  },
  Image233x100: {
    aspectRatio: 2.33,
    aspectRatioAsRatio: '2.33:1',
    type: 'Image233x100',
    editorTitle: () => _TL_('Edit image: 2.33 : 1 aspect ratio'),
  },
  // Image320x100 use the one defined in displayAdsAspectRatioConfig
};

export const aspectRatioConfig = {
  Image201x100: {
    aspectRatio: 2.01,
    aspectRatioAsRatio: '201:100',
    type: 'Image201x100',
    editorTitle: isLogo => isLogo ?
      _TL_('Edit logo: 2.01 : 1 aspect ratio') : _TL_('Edit image: 2.01 : 1 aspect ratio'),
  },
  Image200x100: {
    aspectRatio: 2,
    aspectRatioAsRatio: '200:100',
    type: 'Image200x100',
    editorTitle: isLogo => isLogo ?
      _TL_('Edit logo: 2 : 1 aspect ratio') : _TL_('Edit image: 2 : 1 aspect ratio'),
  },
  Image191x100: {
    aspectRatio: 1.91,
    aspectRatioAsRatio: '191:100',
    type: 'Image191x100',
    editorTitle: isLogo => isLogo ?
      _TL_('Edit logo: 1.91 : 1 aspect ratio') : _TL_('Edit image: 1.91 : 1 aspect ratio'),
  },
  Image4x1: {
    aspectRatio: 4,
    aspectRatioAsRatio: '4:1',
    type: 'Image4x1',
    editorTitle: isLogo => isLogo ?
      _TL_('Edit logo: 4 : 1 aspect ratio') : _TL_('Edit image: 4 : 1 aspect ratio'),
  },
  Image1x1: {
    aspectRatio: 1,
    aspectRatioAsRatio: '1:1',
    type: 'Image1x1',
    editorTitle: isLogo => isLogo ?
      _TL_('Edit logo: 1 : 1 aspect ratio') : _TL_('Edit image: 1 : 1 aspect ratio'),
  },
  Image1x2: {
    aspectRatio: 0.5,
    aspectRatioAsRatio: '1:2',
    type: 'Image1x2',
    editorTitle: isLogo => isLogo ?
      _TL_('Edit logo: 1 : 2 aspect ratio') : _TL_('Edit image: 1 : 2 aspect ratio'),
  },
  Image178x100: {
    aspectRatio: 1.78,
    aspectRatioAsRatio: '178:100',
    type: 'Image178x100',
    editorTitle: isLogo => isLogo ?
      _TL_('Edit logo: 1.78 : 1 aspect ratio') : _TL_('Edit image: 1.78 : 1 aspect ratio'),
  },
  Image169x100: {
    aspectRatio: 1.69,
    aspectRatioAsRatio: '169:100',
    type: 'Image169x100',
    editorTitle: isLogo => isLogo ?
      _TL_('Edit logo: 1.69 : 1 aspect ratio') : _TL_('Edit image: 1.69 : 1 aspect ratio'),
  },
  Image153x100: {
    aspectRatio: 1.53,
    aspectRatioAsRatio: '153:100',
    type: 'Image153x100',
    editorTitle: isLogo => isLogo ?
      _TL_('Edit logo: 1.53 : 1 aspect ratio') : _TL_('Edit image: 1.53 : 1 aspect ratio'),
  },
  Image150x100: {
    aspectRatio: 1.5,
    aspectRatioAsRatio: '150:100',
    type: 'Image150x100',
    editorTitle: isLogo => isLogo ?
      _TL_('Edit logo: 1.5 : 1 aspect ratio') : _TL_('Edit image: 1.5 : 1 aspect ratio'),
  },
  Image133x100: {
    aspectRatio: 1.33,
    aspectRatioAsRatio: '133:100',
    type: 'Image133x100',
    editorTitle: isLogo => isLogo ?
      _TL_('Edit logo: 1.33 : 1 aspect ratio') : _TL_('Edit image: 1.33 : 1 aspect ratio'),
  },
  Image124x100: {
    aspectRatio: 1.24,
    aspectRatioAsRatio: '124:100',
    type: 'Image124x100',
    editorTitle: isLogo => isLogo ?
      _TL_('Edit logo: 1.24 : 1 aspect ratio') : _TL_('Edit image: 1.24 : 1 aspect ratio'),
  },
  Image120x100: {
    aspectRatio: 1.20,
    aspectRatioAsRatio: '120:100',
    type: 'Image120x100',
    editorTitle: isLogo => isLogo ?
      _TL_('Edit logo: 1.20 : 1 aspect ratio') : _TL_('Edit image: 1.20 : 1 aspect ratio'),
  },
  ...displayAdsAspectRatioConfig,
  ...imageExtensionAspectRatioConfig,
  ...boostAspectRatioConfig,
};
const getRatio = (width, height) => width / height;

export const getOriginalImageAspectRatio = (baseImage) => {
  if (baseImage && baseImage.Width > 0 && baseImage.Height > 0) {
    return getRatio(baseImage.Width, baseImage.Height);
  }

  return null;
};

export const getAllowedAspectRatio = (baseImage) => {
  if (baseImage && baseImage.Type) {
    return aspectRatioConfig[baseImage.Type].aspectRatio;
  }

  return 0;
};

// if type is passed, use type as aspect ratio,
// otherwise calculate based on existing width, height info
export const getAspectRatio = (baseImage, cropSettings) => {
  const allowedAspectRatio = getAllowedAspectRatio(baseImage);

  // respect existing aspect ratio info if any
  if (allowedAspectRatio > 0) {
    return allowedAspectRatio;
  }

  // if no defined aspect ratio, use existing crop box to compute ratio
  if (cropSettings && cropSettings.SourceWidth > 0 && cropSettings.SourceHeight > 0) {
    return getRatio(cropSettings.SourceWidth, cropSettings.SourceHeight);
  }

  // lastly use original image to compute ratio
  return getOriginalImageAspectRatio(baseImage);
};

// use maxHeight as default height. If scaling width exceeds maxWidth, use maxWidth as default width
export const getResizeImageHeight = ({
  aspectRatio,
  maxWidth,
  maxHeight,
}) => {
  if (aspectRatio > 0 && maxWidth > 0 && maxHeight > 0) {
    let height = maxHeight;

    if (height * aspectRatio > maxWidth) {
      height = Math.round(maxWidth / aspectRatio);
    }

    return height;
  }

  return undefined;
};

export const convertAspectRatioDecimalToRatio = (aspectRatioAsDecimal) => {
  const { aspectRatioAsRatio } =
    _.find(aspectRatioConfig, ({ aspectRatio }) => aspectRatio === aspectRatioAsDecimal) || {};

  return aspectRatioAsRatio;
};

export const convertAspectRatioToDecimal = (aspectRatioRatio) => {
  const { aspectRatio } =
    _.find(aspectRatioConfig, ({ aspectRatioAsRatio }) => aspectRatioRatio === aspectRatioAsRatio)
    || {};

  return aspectRatio ? `${aspectRatio}` : undefined;
};
